module.exports = __webpack_public_path__ + "static/media/elements_section3.d139bc87.png";